import type { FieldViewProps } from '../../types'
import type BooleanController from './Controller'

import React from 'react'

import { Switch } from '@/shared/components/ui/switch'

import { Operators } from '../../constants'

type Props = FieldViewProps<BooleanController>
export default function BooleanView({
	onChange,
	storedValue,
	disabled,
}: Props) {
	const checked = storedValue.value === '1' || storedValue.value === 1

	const handleChange = () => {
		onChange({ operation: Operators.BL, value: checked ? 0 : 1 })
	}

	return (
		<div className='flex items-center gap-2'>
			<Switch
				data-testid='query-builder-value-checkbox'
				checked={checked}
				disabled={disabled}
				onCheckedChange={handleChange}
			/>
		</div>
	)
}
